export const buildCalendarWeeks = (currentMonth) => {
  const startOfMonth = currentMonth.clone().startOf('month');
  const endOfMonth = currentMonth.clone().endOf('month');
  const day = startOfMonth.clone().startOf('week');
  const endDate = endOfMonth.clone().endOf('week');
  const calendarWeeks = [];

  while (day.isBefore(endDate, 'day')) {
    calendarWeeks.push(
      Array.from({ length: 7 }, () => {
        const calendarDay = day.clone();
        day.add(1, 'day');
        return calendarDay;
      })
    );
  }

  return calendarWeeks;
};